export const preparePresentations = arrayData => {
  if (!arrayData.length) return [];

  return arrayData.map((item) => {
    return {
      id: item.id,
      name: item.date + ' ' + item.note,
    };
  });
};